/**
 * Variation Selector Component
 * 
 * Component for selecting product variations
 */

import { __ } from '@wordpress/i18n';

const VariationSelector = ({ variations, selectedVariation, onVariationSelect, _isMobile }) => {
    
    if (!variations || variations.length === 0) {
        return (
            <div className="fos-variation-section">
                <p className="fos-text-muted">{__('此商品沒有可用變體', 'frontend-order-system')}</p>
            </div>
        );
    }
    
    // If only one variation, don't show selector
    if (variations.length === 1) {
        return null;
    }
    
    return (
        <div className="fos-variation-section fos-slide-up">
            <h4 className="fos-variation-title">
                {__('選擇商品變體', 'frontend-order-system')}
            </h4>
            
            <div className="fos-variation-list">
                {variations.map((variation) => (
                    <div
                        key={variation.variation_id}
                        className={`fos-variation-item ${
                            selectedVariation?.variation_id === variation.variation_id ? 'selected' : ''
                        }`}
                        onClick={() => onVariationSelect(variation)}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onVariationSelect(variation);
                            }
                        }}
                        aria-label={`${__('選擇變體', 'frontend-order-system')}: ${variation.variation_name}`}
                    >
                        <div className="fos-variation-content">
                            <div className="fos-variation-info">
                                <span className="fos-variation-name">
                                    {variation.variation_name}
                                </span>
                                {variation.price && (
                                    <span className="fos-variation-price">
                                        ${variation.price}
                                    </span>
                                )}
                            </div>
                            
                            {selectedVariation?.variation_id === variation.variation_id && (
                                <span className="fos-variation-check" aria-hidden="true">
                                    ✓
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            
            {!selectedVariation && (
                <div className="fos-variation-instruction" style={{
                    marginTop: '12px',
                    padding: '8px 12px',
                    background: '#fff3cd',
                    color: '#856404',
                    borderRadius: '4px',
                    fontSize: '0.9rem'
                }}>
                    <span>💡</span> {__('請選擇一個變體以繼續', 'frontend-order-system')}
                </div>
            )}
        </div>
    );
};

export default VariationSelector;
